import type { ReactNode } from 'react';

export function EmptyState({
  title,
  hint,
  action,
}: {
  title: string;
  hint?: string;
  action?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center gap-3 px-6 py-10 text-center">
      <p className="text-[14px] text-txt">{title}</p>
      {hint !== undefined && <p className="max-w-[42ch] text-[12px] text-dim">{hint}</p>}
      {action}
    </div>
  );
}
